module.exports={
    btn:{
        tips_reelect_btn:"Nowy wygląd",
        cancel_btn:"Anulować",
        tips_continue_dispose:"Skalowanie obsługiwanych obrazów",
        tips_return:"Nowy wygląd",
        tips_upgrade:"Aktualizacja",
        tips_yes:"OK",
        delete:"Usuwać",
        download:"Pobierać",
        upload_image:"Załaduj obrazek",
        new_image:"Nowy wygląd",
        save_all:"Zapisz wszystko",
        cancel:"Anulowanie",
        save:"Ratować",
        view_comparison:"Zobacz porównanie",
        hide_comparison:"Ukryj porównanie",
        previous:"Poprzedni",
        next:"Następny",
        continue_download:"Zapisz obrazy ze znakami wodnymi",
        present:"Zastosuj do tego obrazu",
        all_wait:"Zastosuj do obrazów oczekujących",
        all:"Zastosuj do wszystkich obrazów",
        history:"Historia",
        login:"Zaloguj sie",
    },
    tips:{
        please_upgrade:"Twój obecny plan nie obsługuje przesyłania lub zwiększania rozmiaru obrazów w partiach. Zaktualizuj go, aby uzyskać więcej korzyści.",
        errorlistinfo:"Wybrano obrazy XXX. Obrazy XXX są obsługiwane, ale obrazy XXX nie są obsługiwane. Oto nieobsługiwane obrazy:",
        max:"Przekrocz maksymalny limit rozmiaru obrazu wynoszący 10 MB!",
        max_size:"Przekrocz maksymalną długość boku obrazu wynoszącą 4096 pikseli!",
        continue_dispose:"Skalowanie obsługiwanych obrazów",
        please_multiple:"Wybierz powiększenie.",
        max_multiple:"* Twój obraz zostanie powiększony maksymalnie do 4K (najdłuższy bok nie przekroczy 4096px).",
        title:"Nazwa",
        reasons:"Powody",
        upload_type:"Nieobsługiwany",
        used_up:"Liczba zapisanych obrazów HD bez znaków wodnych została wyczerpana. Uaktualnij swoje konto. Możesz też zapisywać obrazy HD ze znakami wodnymi.",
        edit_multiple:"Przesłano wiele obrazów. Wybierz obrazy, dla których chcesz zmienić powiększenie. Po wybraniu obrazy te zostaną ponownie przeskalowane do nowego powiększenia.",
        download_confirm:"Niektóre obrazy są nadal przetwarzane. Czy na pewno chcesz zapisać wszystkie przeskalowane obrazy? W przypadku wielokrotnego zapisywania tego samego obrazu liczba zapisanych obrazów nie zostanie ponownie odjęta.",
        waiting_save:"Niektóre obrazy są nadal przetwarzane. Zapisz później.",
        
    },
    header:{
        title:"Aiseesoft Image Upscaler Online",
        hd:" obrazy HD",
        watermarks:"bez znaków wodnych można obecnie pobrać.",
        view_details:"Pokaż szczegóły",
        loading:"Ładowanie…",
    },
    content:{
        failed:"Przegrany",
        completed:"Zakończony",
        processing:"Przetwarzanie",
        img_processing:"Przetwarzanie…",
        img_failed:"Przetwarzanie nie powiodło się",
        uploading:"Przesyłanie",
        img_uploading:"Przesyłanie…",
        wait_upoading:"Oczekiwanie na przesłanie…",
        waiting:"Czekanie",
        img_waiting:"Czekanie…",
        empty:"Pusty",
        magnification:"Powiększenie:",
        drop:"Lub upuść plik obrazu tutaj, aby przeskalować i ulepszyć!",
        original:"Oryginalny:",
        output:"Wyjście:",
        img_rendering1:"Twój obraz został przeskalowany.",
        img_rendering2:"Pracujemy nad wyrenderowaniem wysokiej jakości obrazu do podglądu, proszę czekać...",
        no_watermark:"Po zapisaniu obraz nie posiada znaku wodnego.",
    },
    banner_msg:"Wybierz plan dla Upscalera obrazu",
    monthly:"MIESIĘCZNY",
    lifetime:"DOŻYWOTNI",
    choose_plan:"Wybierz swój plan na podstawie liczby obrazów",
    return_home:"Gratulacje! Uaktualniłeś pomyślnie. Wróć do strony głównej i skorzystaj z tego produktu.",
    congratulations:"Gratulacje! Uaktualniłeś pomyślnie. Korzyści zostały przypisane do adresu e-mail, który zostawiłeś podczas aktualizacji. Proszę korzystać z konta zarejestrowanego lub powiązanego z adresem e-mail do",
    login_benefits:"zaloguj się, aby korzystać z korzyści",
    no_registered:". Jeśli nie zarejestrowałeś się lub nie powiązałeś konta z adresem e-mail, proszę",
    register_account:"użyj adresu e-mail do rejestracji konta",
    other_accounts:" lub połącz inne konta z tym adresem e-mail w celu korzystania z korzyści.",
    btn_close:"Zamknąć",
    free:"Bezpłatny",
    btn_get_started:"Zaczynaj",
    // access_to:"Dostęp do",
    upscale_images:"Ekskluzywne obrazy",
    up_to:"Aż do",
    per_image:" na obraz",
    resolution_of:"Do rozdzielczości ",
    default_level:"Skaluj obrazy na poziomie domyślnym",
    image_downloads:"2 obrazy HD do pobrania bez znaku wodnego",
    unlimited_image:"Nieograniczone pobieranie obrazów ze znakiem wodnym",
    SHA256_encryption:"Technika szyfrowania SHA256",
    mon:"Miesięczny",
    images:"obrazy",
    high_resolution:" z jakością wysokiej rozdzielczości",
    tax_incl:"z podatkiem",
    image:"obraz",
    secure_checkout:"Kontrola",
    everything:"Wszystko za darmo i",
    upscaling_levels:"Można wybrać wszystkie poziomy upscalingu",
    unlimited_image_without:"Nieograniczone pobieranie obrazów bez znaku wodnego",
    viewable_editing:"Widoczna historia edycji jest ważna dla",
    days:" dni",
    high_level:"Wysoki poziom",
    priority_processing:" przetwarzanie priorytetowe",
    left:"Dożywotni",
    resolution:" rezolucja",

    "history_will":"Wygaśnie po",
    "history.days":"Dni)",
    "history.hours":"godziny",
    "expired":"Wygasły",
    "access_to":"Dzięki bezpłatnemu okresowi próbnemu możesz tylko",
    "pricing.upload_images":"Przesyłać zdjęcia",
    "pricing.under":"pod ",
    "pricing.images":"obrazy",
    "pricing.without_watermark":"bez znaku wodnego",
    "pricing.process_images":"Przetwarzaj obrazy do",
    "pricing.pixels":"piksele",
    "pricing.enjoy_limited":"Ciesz się ograniczonymi ekskluzywnymi ocenami",
    "pricing.download":"Pobierać",
    "pricing.HD_images":"Obrazy HD bez znaku wodnego",
    "pricing.and_you":"I możesz cierpieć",
    "pricing.slow_upscaling":"powolne skalowanie",
    "pricing.lower_priority":"niższy priorytet",
    "pricing.without":"bez znaku wodnego",
    "pricing.tax":"Podatek jest wliczony w cenę sprzedaży i zostanie obliczony automatycznie na podstawie Twojego kraju i regionu. W koszyku możesz zobaczyć szczegółową kwotę podatku. Twoja ostateczna kwota płatności będzie taka sama jak wyświetlona cena.",
    "pricing.you_can":"Z abonamentem możesz",
    "pricing.up_to":"Prześlij obrazy do",
    "pricing.upscale_images":"Ekskluzywne obrazy z",
    "pricing.no_watermark":"bez znaku wodnego",
    "pricing.enhance":"Zwiększyć",
    "pricing.or_more":"obrazy lub więcej",
    "pricing.in_batch":"w partii",
    "pricing.enlarge_images":"Powiększ obrazy w",
    "pricing.and":"I",
    "pricing.times_with":"razy bez limitu",
    "pricing.enjoy":"Cieszyć się",
    "pricing.of_history":"czasu przechowywania historii",
    "pricing.experience":"Doświadczenie",
    "pricing.fast_upscaling":"szybkie skalowanie",
    "pricing.higher_priority":"wyższy priorytet",
    "pricing.early_access":"Wczesny dostęp do nowych funkcji",
    "pricing.cancel_anytime":"Anuluj w dowolnym momencie",
    "pricing.lifetime_license":"Z dożywotnią licencją możesz",
    "pricing.and_there":"I będzie",
    "pricing.no_expiration":"brak daty ważności",
    "pricing.unless":"chyba że wyczerpią Ci się wszystkie upscalery",

    "buynow.pop.credit":"kredyt",
    "buynow.pop.credits":"kredyty",

    "isUnderequityTip_msg1":"Wybrałeś obrazy {%} do przetwarzania wsadowego i nie ma wystarczającej liczby pozostałych korzyści. Nadal potrzebujesz {%} kredytów (obecnie pozostało {%} kredytów), Jeśli musisz przetworzyć, kup korzyści, aby kontynuować przetwarzanie obrazów.",
    "isUnderequityTip_msg2":"Wybrałeś obrazy {%} do przetwarzania wsadowego i nie ma wystarczającej liczby pozostałych korzyści. Nadal potrzebujesz {%} kredytów (obecnie pozostało {%} zdjęć korzyści), Jeśli chcesz przetworzyć, kup korzyści aby kontynuować przetwarzanie obrazów.",
    "isUnderequityTip_msg3":"Wybrałeś obrazy {%} do przetwarzania wsadowego i nie ma wystarczającej liczby pozostałych korzyści. Nadal potrzebujesz {%} kredytów (obecnie pozostało {%} kredytów, pozostało {%} zdjęć korzyści), Jeśli potrzebujesz procesu, należy zakupić korzyści, aby kontynuować przetwarzanie obrazów.",
    "btn_buy_now":"Kup Teraz",
    "isEquityDepletionTip_msg":"Twoje obecne korzyści zostały wyczerpane. Prosimy wykupić korzyści w celu przetwarzania wsadowego.",

    "pricing.h1":"Aiseesoft AI Photo Editor - Plany i Ceny",
    "pricing.banner_content":"Zdobądź kredyty AI Photo Editor, aby usuwać tła obrazów, skalować obrazy i usuwać obiekty z obrazów online lub z pulpitu.",
    "pricing.best_seller":"Bestseller",
    "pricing.monthly":"Subskrypcja Miesięczna",
    "pricing.credits":"kredyty",
    "pricing.lifetime":"Dożywotni",
    "pricing.note":"Uwaga",
    "pricing.buy_now":"Kup Teraz",
    "pricing.note_content":"Zakupione kredyty są powiązane z adresem e-mail wprowadzonym w koszyku. Aby korzystać z tych kredytów, zarejestruj się lub zalogj używając tego samego adresu e-mail.",

    "header.buy_more":"Kup więcej",
    "header.available_credits":"Dostępne kredyty",
    "header.credits":"kredyt(y)"
}